import { useDirection } from '@radix-ui/react-direction'
import { X } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { hasAnyConsent, initTrackingScripts, setCookieConsent } from '@/lib/cookieConsent'

export const CookieConsent: React.FC = () => {
  const { t } = useTranslation()
  const [showBanner, setShowBanner] = useState(false)
  const isRTL = useDirection() === 'rtl'

  useEffect(() => {
    if (!hasAnyConsent()) {
      setShowBanner(true)
    } else {
      initTrackingScripts()
    }
  }, [])

  const handleUnderstand = () => {
    const newPreferences = { analytics: true, marketing: true }
    setCookieConsent(newPreferences)
    setShowBanner(false)
    initTrackingScripts()
  }

  if (!showBanner) {
    return null
  }

  return (
    <div
      className='fixed start-0 end-0 bottom-0 z-50 border-t border-gray-200 bg-white p-4 shadow-lg md:p-6'
      dir={isRTL ? 'rtl' : 'ltr'}
      style={{ direction: isRTL ? 'rtl' : 'ltr' }}
    >
      <div className='relative container mx-auto max-w-6xl'>
        <Button
          onClick={handleUnderstand}
          className='absolute end-0 -top-2 size-8'
          aria-label={t('common.close')}
          type='button'
          variant='ghost'
          size='icon'
        >
          <X className='h-5 w-5' />
        </Button>
        <div className='flex flex-col items-start gap-4 md:flex-row md:items-end'>
          <div className='flex-1'>
            <h3 className='mb-2 text-lg font-semibold'>{t('cookieConsent.title')}</h3>
            <p className='mb-0 text-sm text-gray-700'>{t('cookieConsent.description')}</p>
            <p className='mt-2 mb-0 text-xs text-gray-600'>
              {t('cookieConsent.privacyPrefix')}{' '}
              <a href='https://shiptanbul.com/privacy' className='text-blue-600 underline hover:text-blue-800'>
                {t('cookieConsent.privacyLink')}
              </a>{' '}
              {t('cookieConsent.privacySuffix')}
            </p>
          </div>
          <div className='flex w-full md:w-auto'>
            <Button variant='default' size='sm' onClick={handleUnderstand} className='whitespace-nowrap'>
              {t('cookieConsent.understand')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
